import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import DashboardModel from '../model/DashboardModel.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetDashboard
 * @method apiGetSubDashboard
 */
export default {
    /**
     * Get main dashboard
     * @param {object} params DashboardConfigModel - /core/Campaign/model/DashboardConfigModel.js
     * @return {Promise} list of DashboardModel
     */
    apiGetDashboard: function(params) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + '/main/dashboard';
        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                var data = res.data;
                if (data instanceof Array) {
                    var listDashboard = [];
                    for (var i of data) {
                        listDashboard.push(new DashboardModel(i));
                    }
                    return listDashboard;
                } else {
                    return null;
                }
            }));
    },

    /**
     * Get custom dashboard
     * @param {object} params (require) SubDashboardConfigModel  - /service/config/DashboardConfigModel.js
     * @return {import("rxjs").Observable} list of DashboardModel
     */
    apiGetSubDashboard: function (params, dashboardName) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + `/dashboard/${dashboardName}`;
        return BzbsApi.connectBzbsGet(url, token, params)
            .pipe(map((res) => {
                var data = res.data;
                if (data instanceof Array) {
                    var listDashboard = [];
                    for (var i of data) {
                        listDashboard.push(new DashboardModel(i));
                    }
                    return listDashboard;
                } else {
                    return null;
                }
            }));
    }
}
